import PaywallProBgRebrand from '@/assets/image/free-to-pay/paywall-pro-bg-jpg/paywall-pro-bg-rebrand.png';
import Image, { type ImageProps } from 'next/image';

export const PaywallProBgJpg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'paywall pro bg', ...rest } = props;

  return <Image src={PaywallProBgRebrand} alt={alt} {...rest} />;
};
